import { render, staticRenderFns } from "./Hak.vue?vue&type=template&id=3e9d4013&scoped=true"
import script from "./Hak.vue?vue&type=script&lang=js"
export * from "./Hak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9d4013",
  null
  
)

export default component.exports